define('blocks/request-form/request-form',['require','../../../cloud-web/js/radar','validate-js','../../../common/js/phoneHelpers'],function(require) {
    var $button = $('.js-open-form');
    var $body = $('body');
    var modal = $('#request-form');

    $button.on('click', function(event) {
        modal.addClass('open');
        $body.addClass('noscroll');
    });

    modal.on('click', '.js-close', function(event) {
        modal.removeClass('open');
        $body.removeClass('noscroll');
    });

    // Нажатие на фон модалки
    modal.on('click', function(event) {
        if (event.target === event.currentTarget) {
            modal.removeClass('open');
            $body.removeClass('noscroll');
        }
    });

    var radar = require('../../../cloud-web/js/radar');
    var validate = require('validate-js');
    var phoneHelpers = require('../../../common/js/phoneHelpers');
    var $popupSuccess = $('#popup-succes');
    var $popupError = $('#popup-error');
    var $form = $('#request-form form');
    var errorClass = '-error';


    var $inputs = {
        name: $form.find('input[name="fb.user_name"]'),
        company: $form.find('input[name="fb.question.57809"]'),
        phone: $form.find('input[name="fb.question.57810"]'),
        email: $form.find('input[name="fb.communication_email"]'),
        message: $form.find('textarea[name="fb.message"]'),
    }

    validate.validators.phone = function(value, options, key, attributes) {
        return phoneHelpers.isValidPhone(phoneHelpers.processPhone(value)) ? null : 'is totally wrong';
    };


    var constraints = {
        company: {
            presence: { allowEmpty: false }
        },
        phone: {
            phone: true
        },
        email: {
            presence: { allowEmpty: false },
            email: true
        },
        message: {
            presence: { allowEmpty: false }
        }
    };


    $form.on('change input', 'input[required], textarea[required]', function(event) {
        var input = event.currentTarget;

        if (!input.value.trim()) {
            input.classList.add(errorClass);
        } else {
            input.classList.remove(errorClass);
        }
    });

    $inputs.phone.on('change', function(event) {
        event.currentTarget.value = phoneHelpers.formatPhone(event.currentTarget.value);
    });


    function validateForm() {
        var values = {
            company: $inputs.company.val(),
            phone: $inputs.phone.val(),
            email: $inputs.email.val(),
            message: $inputs.message.val(),
        };

        var errors = validate(values, constraints);

        console.log(values);
        console.log(errors);

        Object.keys($inputs).forEach(function(name) {
            if (errors && name in errors) {
                $inputs[name].addClass(errorClass);
                return;
            }
            $inputs[name].removeClass(errorClass);
        });

        return !errors;
    }

    function handleDone(response) {
        if (response && response.status === 'ok') {
            $popupSuccess.show();
            $form.trigger('reset');
            radar.ga({
                category: 'form',
                action: 'success'
            });
            return;
        }

        radar.ga({
            category: 'form',
            action: 'error',
            label: 'server'
        });

        console.error(response);

        if (response && response.errors && response.errors.fields) {
            Object.keys(response.errors.fields).map(function(name) {
                $form.find('input[name="' + name + '"]').addClass(errorClass);
            });
            return;
        }

        $popupError.show();
    }

    function handleFail(error) {
        $popupError.show();

        radar.ga({
            category: 'form',
            action: 'error',
            label: 'server'
        });

        console.error(error);
    }

    $form.on('submit', function(event) {
        event.preventDefault();
        var form = event.currentTarget;

        radar.ga({
            category: 'form',
            action: 'submit'
        });

        if (!validateForm()) {
            radar.ga({
                category: 'form',
                action: 'error',
                label: 'client'
            });
            return;
        }

        var formData = new FormData(form);

        formData.append('need_json', '1');

        $.ajax({
            url: form.action,
            method: form.method,
            data: formData,
            dataType: 'json',
            processData: false,  // Сообщить jQuery не передавать эти данные
            contentType: false   // Сообщить jQuery не передавать тип контента
        }).done(handleDone).fail(handleFail);
    });
})
;
